
import React, { } from 'react';
import { professional } from '../../helper/constants/contacts';
import { SpeedDial, SpeedDialAction } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { NeutralColor } from '../../helper/constants/colors';
import { useMenu } from '../../helper/functions/hooks/menu';
import { useScrollPosition } from '../../helper/functions/hooks/scroll';
import RenderIf from '../RenderIf';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ContactProps } from './helper';
import { usePublisher } from '../../helper/functions/hooks/events';
import { HIDE_BUTTON } from '../../events';


const Contact = ({ visible }: ContactProps): JSX.Element => {

    const { opened, openMenu, closeMenu, openExternal } = useMenu()
    const scroll = useScrollPosition()
    const publish = usePublisher()

    return (
        <RenderIf condition={visible}>
            <SpeedDial
                ariaLabel="SpeedDial controlled open example"
                sx={{ position: 'absolute', bottom: 16 + scroll, right: 16 }}
                icon={<PersonAddIcon />}
                onClose={closeMenu}
                onOpen={openMenu}
                open={opened}
                color='white'
                FabProps={{
                    sx: {
                        bgcolor: NeutralColor.light,
                        '&:hover': {
                            bgcolor: NeutralColor.light,
                        }
                    }
                }}>
                <SpeedDialAction
                    icon={<VisibilityOffIcon/>}
                    tooltipTitle="Hide"
                    tooltipOpen
                    onClick={(): void => {
                        closeMenu()
                        publish<boolean>(HIDE_BUTTON, false)
                    }}
                />
                {
                    professional.map((contact, i) => (
                        <SpeedDialAction
                            key={i}
                            icon={contact.icon}
                            tooltipTitle={contact.title}
                            tooltipOpen
                            onClick={(): void => openExternal(contact.href)}
                        />
                    ))
                }
            </SpeedDial>
        </RenderIf>
    )
}


export default Contact;
